"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FlexConstants = require("./FlexConstants");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  flex-grow: 1;\n  align-items: ", ";\n  align-self: ", ";\n  flex-direction: ", ";\n  justify-content: ", ";\n  flex-wrap: ", ";\n  max-width: 100%;\n  width: 100%;\n\n  & > .private-flex {\n    width: auto;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledFlex = _styledComponents.default.div.withConfig({
  displayName: "UIFlex__StyledFlex",
  componentId: "sc-16apios-0"
})(_templateObject(), function (props) {
  return _FlexConstants.ALIGN_OPTIONS[props.align];
}, function (props) {
  return _FlexConstants.ALIGN_SELF_OPTIONS[props.alignSelf];
}, function (props) {
  return _FlexConstants.DIRECTION_OPTIONS[props.direction];
}, function (props) {
  return _FlexConstants.JUSTIFY_OPTIONS[props.justify];
}, function (props) {
  return _FlexConstants.WRAP_OPTIONS[props.wrap];
});

var UIFlex = (0, _react.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["className"]);
  return _react.default.createElement(StyledFlex, (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)('private-flex', className),
    ref: ref
  }));
});
UIFlex.propTypes = {
  align: _propTypes.default.oneOf(Object.keys(_FlexConstants.ALIGN_OPTIONS)),
  alignSelf: _propTypes.default.oneOf(Object.keys(_FlexConstants.ALIGN_SELF_OPTIONS)),
  children: _propTypes.default.node,
  direction: _propTypes.default.oneOf(Object.keys(_FlexConstants.DIRECTION_OPTIONS)),
  justify: _propTypes.default.oneOf(Object.keys(_FlexConstants.JUSTIFY_OPTIONS)),
  wrap: _propTypes.default.oneOf(Object.keys(_FlexConstants.WRAP_OPTIONS))
};
UIFlex.defaultProps = {
  align: 'start',
  direction: 'row',
  justify: 'start',
  wrap: 'nowrap'
};
UIFlex.displayName = 'UIFlex';
var _default = UIFlex;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3773/js/layout/UIFlex.js
// module id = 278
// module chunks = 0